// Уроки без регистрации. 16.10.2026 гостю открыли первый урок курса
// "Здравствуй" (части 1 и 2), 17.10.2026 решение владельца расширило это до
// восьми уроков курса. 25.10.2026 владелец сузил гостевой период до
// ЧЕТЫРЁХ уроков, с "Здравствуй" (a1-l003) по a1-l006, и обоих уроков
// алфавита (.scratch/guest-mode/plan.md): регистрация раньше, пейволл тоже
// раньше (lib/access.ts FREE_COURSE_LESSONS_NEW), гипотеза с сессии 25.10 —
// кто дошёл до 3-4 урока гостем, регистрируется спокойно, решающий порог не
// в точности 8, а сам факт, что урок 1 пройден. Все три части каждого урока:
// "Разговор" играет записанную озвучку и голос браузера, AI в нём нет.
// Прогресс гостя лежит в браузере (lib/guest-progress.ts) и после входа
// переносится на сервер страницей /guest-sync. Стена со входом стоит после
// четвёртого урока, перед a1-l007 "Числа" (components/guest-wall.tsx).

export const GUEST_LESSON_SLUG = 'a1-l003'

// Уроки курса по порядку: номер урока для гостя = индекс + 1.
export const GUEST_COURSE_SLUGS = ['a1-l003', 'a1-l004', 'a1-l005', 'a1-l006'] as const
// Алфавит не обязателен никому (правило 3) и открыт гостю целиком.
export const GUEST_ALPHABET_SLUGS = ['a1-l001', 'a1-l002'] as const
export const GUEST_SLUGS: readonly string[] = [...GUEST_ALPHABET_SLUGS, ...GUEST_COURSE_SLUGS]
// Урок, перед которым стена: после четырёх уроков вход сохраняет прогресс.
export const GUEST_WALL_BEFORE = 'a1-l007'
// С какого пройденного урока на финале плашка "Сохраните прогресс" (из
// четырёх гостевых — пропорционально прежним 3 из 8).
export const GUEST_SAVE_HINT_FROM = 2

export function isGuestSlug(slug: string): boolean {
  return GUEST_SLUGS.includes(slug)
}

// Номер урока курса для гостя (1-8), 0 - не урок курса из гостевых (алфавит, остальные).
export function guestLessonNumber(slug: string): number {
  return (GUEST_COURSE_SLUGS as readonly string[]).indexOf(slug) + 1
}

export function guestLessonHref(slug: string = GUEST_LESSON_SLUG): string {
  return `/lesson/${slug}`
}

// Путь, который proxy пускает без сессии: любой из гостевых уроков.
export function isGuestLessonPath(pathname: string): boolean {
  const m = /^\/lesson\/([^/]+)$/.exec(pathname)
  return !!m && isGuestSlug(m[1])
}

// Что proxy пускает без сессии: гостевые уроки и урок со стеной (страница урока
// показывает гостю components/guest-wall.tsx вместо урока).
export function isGuestOpenPath(pathname: string): boolean {
  return isGuestLessonPath(pathname) || pathname === guestLessonHref(GUEST_WALL_BEFORE)
}

// Куда вести после входа гостя: сначала /guest-sync переносит уроки из браузера
// на сервер, потом открывает target. Без этого страница урока проверила бы
// цепочку по базе раньше, чем уроки туда попали.
export function guestSyncHref(target: string): string {
  return `/guest-sync?next=${encodeURIComponent(target)}`
}

// После входа с таким next онбординг с выбором цели пропускаем: человек уже
// в уроке, вопросы потом (решение владельца 16.10.2026).
export function skipsOnboarding(next: string | null | undefined): boolean {
  return !!next && (next.startsWith('/lesson/') || next.startsWith('/guest-sync'))
}
